import HasID from "./HasID";
import { Prescription } from "@/models/Prescription";
import { Patient } from "@/models/Patient";
import { Prescriber } from "@/models/Prescriber";
import { Store } from "@/models/Store";
import { Drug } from "@/models/Drug/Drug";
import { DispenseError } from "@/models/DispenseError";
import { Order } from "@/models/Order";
import { Escript } from "@/models/Escript";
import { FunctionalityFlag } from "./FunctionalityFlag";

export interface Verification extends HasID {
    store: boolean;
    patient: boolean;
    prescriber: boolean;
    quantity: boolean;
    drug: boolean;
    direction: boolean;
    dur: boolean;
    created: Date;
    createdBy: string;
}

export interface VerificationResponse {
    prescription: Prescription;
    patient: Patient;
    prescriber: Prescriber;
    store: Store;
    drug: Drug;
    verifications: Verification[];
    dispenseErrors: DispenseError[];
    order: Order;
    escript: Escript;
    programFlags: FunctionalityFlag[];
    requireExplicitPV1: boolean;
    requireExplicitPV2: boolean;
    /**
     * When true, the "PV1 Needed" reminder modal at PV2 is suppressed regardless of
     * whether the prescription is a controlled substance, Schedule 1/2 drug, or compound.
     * Resolved server-side: the program-level "Disable PV1 Needed Warning" functionality flag
     * suppresses the modal only when explicitly enabled; otherwise the tenant-level
     * configuration default applies.
     */
    disablePV1NeededWarning: boolean;
    requireExplicitDur: number | null;
    requireDurNotes: boolean;
    patientPendingAllergy: boolean;
    prescriptionCount?: number;
    notesCount?: number;
    thisHistoryCount?: number;
    otherMedsCount?: number;
    inventoryOnHand?: number;
    inventoryAllocated?: number;
}

export namespace Verification {
    export class DrugUtilizationReviews {
        public items?: DURItem[];
        public calculated?: boolean;
        public notes?: string;
    }

    export interface DURItem {
        active: boolean;
        key: string;
        name: string;
        secondaryName?: string;
        ternaryName?: string;
        description: string;
        severity: DURItemSeverityLevel;
        kind: DURItemKind;
        drugName?: string;
        lastFilled?: Date;
        groupName?: string;
        notes?: string;
        status?: boolean;
    }

    export enum DURItemSeverityLevel {
        informational,
        moderate,
        major
    }

    export enum DURItemKind {
        allergy,
        duplicateTherapy,
        drugInteraction,
        pregnancy,
        disease,
        dose
    }
}
